import handleApiError from '@/shared/api/handleApiError';
import { serviceGet } from '@/shared/lib/core/request';
import axios from 'axios';

export const API_CARDS_URL = 'api/cards';
export const serviceGetCards = serviceGet.bind(null, API_CARDS_URL);

type AddCardPayload = {
  clientBitrixId: number,
  phone: string,
  email: string,
  partnerId: number,
}

interface AddCardResponse {
  code?: number,
  data?: {
    'CONTACT_ID': number,
    'PARTNER_ID': number,
    'LOYALTY': string,
    'LOYALTY_CARD': string,
    'PARTNER_CODE': string,
    'LOYALTY_STATUS': string,
    'LOYALTY_DATE': string,
    'LOYALTY_CURRENCY': string,
    'LOYALTY_REF_LINK': string
  }
}

export async function addCard(payload: AddCardPayload): Promise<AddCardResponse> {
  try {
    const { data } = await axios.post('/api/bitrixLinkCard', payload);
    return data?.response ?? {};
  } catch (error) {
    try {
      handleApiError(error);
    } catch {}

    return {};
  }
}
